import { WizardGroupEnum } from "../../enums/wizard-group-enum";
import { WizardNavGroup } from "../wizard-nav-group.model";
import { NavigationType } from "./nav-type.enum";
import { StepConfig } from "./step-config.model";

export class WizardFlowConfig {
  steps: StepConfig[] = [];
  isDefault: boolean = false;
  stepGroups: WizardNavGroup[] = [];
}

export class WizardFlowConfigs {
  applicationFlowConfig!: WizardFlowConfig;
  coApplicationFlowConfig!: WizardFlowConfig;
  registrationFlowConfig!: WizardFlowConfig;

  title: string = "";
  comment: string = "";
  guid: string = "";
  isDefault: boolean = false;
  userCreationAutoConfirmed: boolean = false;
  navigationType: NavigationType = NavigationType.Horizontal;

  hasProgressBar: boolean = true;

  // LLS-255: single flow-wide flag (default true = existing behavior). When false, the co-borrower's
  // sensitive personal fields are shown only if the primary borrower says they'll complete the
  // application for that person. Edited from the My Info + Create Co-Borrowers step pages of the
  // Apply flow; NOT applicable to the Co-Apply flow (there the co-borrower enters their own info).
  allowBorrowerEnterCoBorrowerPersonalInformation: boolean = true;

  constructor(applicationFlowConfig: WizardFlowConfig, coApplicationFlowConfig: WizardFlowConfig, registrationFlowConfig: WizardFlowConfig) {
    this.applicationFlowConfig = applicationFlowConfig;
    this.coApplicationFlowConfig = coApplicationFlowConfig;
    this.registrationFlowConfig = registrationFlowConfig;

    if (!this.applicationFlowConfig.stepGroups || !this.applicationFlowConfig.stepGroups.length) {
      this.applicationFlowConfig.stepGroups = this.getDefaultStepGroups();
    }
  }

  private getDefaultStepGroups(): WizardNavGroup[] {
    // Here you will return the nav groups
    const myInfoGroup = new WizardNavGroup(WizardGroupEnum.MyInfo, "wizard.nav.myInfo", "user-svg-icon", "");
    const myFinancesGroup = new WizardNavGroup(WizardGroupEnum.MyFinances, "wizard.nav.myFinances", "", "fa fa-money-bill-alt");
    const myPropertyAndLoanGroup = new WizardNavGroup(WizardGroupEnum.PropertyAndLoan, "wizard.nav.propertyAndLoan", "", "fas fa-home");
    const myDeclarationsGroup = new WizardNavGroup(WizardGroupEnum.Declarations, "wizard.nav.declarations", "", "far fa-file-alt");
    const myReviewAndSubmitGroup = new WizardNavGroup(WizardGroupEnum.ReviewAndSubmit, "wizard.nav.reviewAndSubmit", "", "fas fa-check-square");
    const navGroups: WizardNavGroup[] = [];
    navGroups.push(myInfoGroup);
    navGroups.push(myFinancesGroup);
    navGroups.push(myPropertyAndLoanGroup);
    navGroups.push(myDeclarationsGroup);
    navGroups.push(myReviewAndSubmitGroup);

    return navGroups;
  }
}
